import React from 'react';

import Difficulty from 'components/shared/Difficulty';

import { DifficultyColumnValue } from '../types';

type DifficultyColumnProps = {
  value: DifficultyColumnValue;
};

const DifficultyColumn = ({ value }: DifficultyColumnProps): JSX.Element => <Difficulty difficulty={value} />;

export default DifficultyColumn;
